module.exports = __webpack_public_path__ + "static/media/99.01771492.png";